



































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import RangeSlider from "@/components/VRangeSliderStyling.vue";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import * as def from '@/definitions'

import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { D3TextLayer } from "@/model/document2/page/surface/design/layer/d3TextLayer";
import { MathHelper } from '@/helper/mathHelper';
import { FontManager } from '@/model/fontManager/fontManager';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import FontSelector from "@/commonComponents/fontSelector/fontSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";

import { ResourceHelper } from "@/helper/resourceHelper";

@Component({
  components: {
        RangeSlider,
        ColorPicker,
        ColorSelector,
        FontSelector,
        AdjustedBalloon,
        ValueEdit,
        ArrowDown,
        ArrowRight,
        DropdownList
  },
})

// テキスト選択時, テキスト非選択時共通
// テキスト選択状態の場合は選択テキスト、非選択時は全テキストに適用する
export default class ThreedText extends Vue
{
    @Prop() private layer! : D3TextLayer;

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus() {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    //こいつはpropsでもらいたい
    openStatus = {
        opend : true
    };

    threedTextContentsOpenAnimate = false;
    threedTextContentsCloseAnimate = false;

    open(){
        if(this.openStatus.opend){
            this.threedTextContentsCloseAnimate = true;
            setTimeout(()=>{this.threedTextContentsCloseAnimate = false; this.threedTextContentsOpenAnimate = false; this.openStatus.opend = false;}, 200);
        }else{
            this.openStatus.opend = true;
            this.threedTextContentsOpenAnimate = true;
            setTimeout(()=>{this.threedTextContentsOpenAnimate = false;}, 250);
        }
    };

    // フォント
    isFontDropdownActive : boolean = false;
    private dropdownListVisibleChanged(isVisible : boolean)
    {
        this.isFontDropdownActive = isVisible;
    }
    private get selectedFontId() { return this.layer.fontId; }
    private getFontManager() : FontManager
    {
        return this.$store.getters.fontManager;
    }
    private onSelectFont(fontId : string)
    {
        this.changeLayerProperty(fontId, "fontId", true);
    }

    // カラーピッカー表示非表示
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }

    // 色変更中
    private onChangingColor(color)
    {
        this.changeLayerProperty(color, "textColor", false);
    }

    // 色変更完了
    private onChangedColor(color)
    {
        this.changeLayerProperty(color, "textColor", true);
    }

    // レイヤー全体の値変更
    private onChangingLayerValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedLayerValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    private get textColor() { return this.layer.textColor; }
    private get textColorStyle()
    {
        return { "background-color" : this.textColor.hex };
    }

    private get opacity() { return this.layer.opacity; }
    private get opacitySliderValue() { return this.opacity; }
    private set opacitySliderValue(value)
    {
        this.changeLayerProperty(value, "opacity", false);
    }
    private onChangeOpacity(value)
    {
        this.changeLayerProperty(value, "opacity", true);
    }

    private get thickness() { return this.layer.thickness; }
    private get thicknessSliderValue() { return this.thickness; }
    private set thicknessSliderValue(value)
    {
        this.changeLayerProperty(value, "thickness", false);
    }
    private onChangeThickness(value)
    {
        this.changeLayerProperty(value, "thickness", true);
    }

    private get rotateY() { return this.layer.rotateY; }
    private get rotateYSliderValue() { return this.rotateY; }
    private set rotateYSliderValue(value)
    {
        this.changeLayerProperty(value, "rotateY", false);
    }
    private onChangeRotateY(value)
    {
        this.changeLayerProperty(value, "rotateY", true);
    }

    private get rotateX() { return this.layer.rotateX; }
    private get rotateXSliderValue() { return this.rotateX; }
    private set rotateXSliderValue(value)
    {
        this.changeLayerProperty(value, "rotateX", false);
    }
    private onChangeRotateX(value)
    {
        this.changeLayerProperty(value, "rotateX", true);
    }

    private get rotateZ() { return this.layer.rotateZ; }
    private get rotateZSliderValue() { return this.rotateZ; }
    private set rotateZSliderValue(value)
    {
        this.changeLayerProperty(value, "rotateZ", false);
    }
    private onChangeRotateZ(value)
    {
        this.changeLayerProperty(value, "rotateZ", true);
    }

    private get lightY() { return this.layer.lightY; }
    private get lightYSliderValue() { return this.lightY; }
    private set lightYSliderValue(value)
    {
        this.changeLayerProperty(value, "lightY", false);
    }
    private onChangeLightY(value)
    {
        this.changeLayerProperty(value, "lightY", true);
    }

    private get lightX() { return this.layer.lightX; }
    private get lightXSliderValue() { return this.lightX; }
    private set lightXSliderValue(value)
    {
        this.changeLayerProperty(value, "lightX", false);
    }
    private onChangeLightX(value)
    {
        this.changeLayerProperty(value, "lightX", true);
    }

    private get lightZ() { return this.layer.lightZ; }
    private get lightZSliderValue() { return this.lightZ; }
    private set lightZSliderValue(value)
    {
        this.changeLayerProperty(value, "lightZ", false);
    }
    private onChangeLightZ(value)
    {
        this.changeLayerProperty(value, "lightZ", true);
    }

    private get reflect() { return this.layer.reflect; }
    private get reflectSliderValue() { return this.reflect; }
    private set reflectSliderValue(value)
    {
        this.changeLayerProperty(value, "reflect", false);
    }
    private onChangeReflect(value)
    {
        this.changeLayerProperty(value, "reflect", true);
    }

    private get brightness() { return this.layer.brightness; }
    private get brightnessSliderValue() { return this.brightness; }
    private set brightnessSliderValue(value)
    {
        this.changeLayerProperty(value, "brightness", false);
    }
    private onChangeBrightness(value)
    {
        this.changeLayerProperty(value, "brightness", true);
    }

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    changeForm(type){
        if(type == 1){
            this.changeLayerProperty(0, "rotateX", false);
            this.changeLayerProperty(0, "rotateY", false);
            this.changeLayerProperty(0, "rotateZ", false);
            this.changeLayerProperty(1, "lightX", false);
            this.changeLayerProperty(1, "lightY", false);
            this.changeLayerProperty(1, "lightZ", false);
            this.changeLayerProperty(64, "reflect", false);
            this.changeLayerProperty(0, "brightness", true);
        }else if(type == 2){
            this.changeLayerProperty(0, "rotateX", false);
            this.changeLayerProperty(0, "rotateY", false);
            this.changeLayerProperty(-45, "rotateZ", false);
            this.changeLayerProperty(1, "lightX", false);
            this.changeLayerProperty(1, "lightY", false);
            this.changeLayerProperty(1, "lightZ", false);
            this.changeLayerProperty(64, "reflect", false);
            this.changeLayerProperty(0, "brightness", true);
        }else if(type == 3){
            this.changeLayerProperty(0, "rotateX", false);
            this.changeLayerProperty(0, "rotateY", false);
            this.changeLayerProperty(45, "rotateZ", false);
            this.changeLayerProperty(1, "lightX", false);
            this.changeLayerProperty(1, "lightY", false);
            this.changeLayerProperty(1, "lightZ", false);
            this.changeLayerProperty(64, "reflect", false);
            this.changeLayerProperty(0, "brightness", true);
        }else if(type == 4){
            this.changeLayerProperty(48, "rotateX", false);
            this.changeLayerProperty(0, "rotateY", false);
            this.changeLayerProperty(0, "rotateZ", false);
            this.changeLayerProperty(1, "lightX", false);
            this.changeLayerProperty(1, "lightY", false);
            this.changeLayerProperty(1, "lightZ", false);
            this.changeLayerProperty(64, "reflect", false);
            this.changeLayerProperty(0, "brightness", true);
        }else if(type == 5){
            this.changeLayerProperty(-48, "rotateX", false);
            this.changeLayerProperty(0, "rotateY", false);
            this.changeLayerProperty(0, "rotateZ", false);
            this.changeLayerProperty(1, "lightX", false);
            this.changeLayerProperty(1, "lightY", false);
            this.changeLayerProperty(1, "lightZ", false);
            this.changeLayerProperty(64, "reflect", false);
            this.changeLayerProperty(0, "brightness", true);
        }else if(type == 6){
            this.changeLayerProperty(0, "rotateX", false);
            this.changeLayerProperty(64, "rotateY", false);
            this.changeLayerProperty(0, "rotateZ", false);
            this.changeLayerProperty(1, "lightX", false);
            this.changeLayerProperty(1, "lightY", false);
            this.changeLayerProperty(1, "lightZ", false);
            this.changeLayerProperty(64, "reflect", false);
            this.changeLayerProperty(0, "brightness", true);
        }else if(type == 7){
            this.changeLayerProperty(0, "rotateX", false);
            this.changeLayerProperty(-64, "rotateY", false);
            this.changeLayerProperty(0, "rotateZ", false);
            this.changeLayerProperty(1, "lightX", false);
            this.changeLayerProperty(1, "lightY", false);
            this.changeLayerProperty(1, "lightZ", false);
            this.changeLayerProperty(64, "reflect", false);
            this.changeLayerProperty(0, "brightness", true);
        }
    }

    private onChangingValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, true);
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}



